export const noLicenseEn = {
  welcomeToYouGile: 'Welcome to YouGile!',
  welcomeToYouGile2: 'Activate the demo license to gain access to the system',
  noActiveLicenseHint: `
    Currently there is no active license. After you’ll activate the demo
    license you’ll receive a demo license that is valid for 7 days.
    After that you can buy a new license and proceed using YouGile.
  `,
  activateButton: 'Activate demo license',
  activatePlatformButton: 'Activate Platform Demo license',
  activateInProgress: 'Initializing demo license, please wait…',
  noValidLicenseFound: 'No valid license found.',
  contactYourAdmin:
    'Please contact your system administrator to update the license.',
  limitIsExceeded:
    'The company has exceeded the limit on employees, contact the administrator',
  tariffBox: 'Boxed version demo',
  tariffBox1p1: 'full YouGile Platform functionality',
  tariffBox1p2: 'on your servers',
  tariffBox2: '100 users',
  tariffBox3: 'Free access for 7 days',
  tariffBox4: 'Activate',
  tariffBox5: 'or use a developer license and the ability to add to the system',
  tariffBox6: 'Developer license',
  tariffBox7: 'maximum 2 users',

  licenseNotActivated: 'Your license is not activated',
  licenseExpired: 'License has expired',
  contactAdministrator:
    'Contact your administrator and renew your license at this rate'
}

export const noLicenseRu: typeof noLicenseEn = {
  welcomeToYouGile: 'Добро пожаловать в YouGile!',
  welcomeToYouGile2:
    'Активируйте демо-лицензию, чтобы получить доступ к системе',
  noActiveLicenseHint:
    'Сейчас нет действующей лицензии. Вы можете активировать демо-лицензию, она будет действовать 7 дней.',
  activateButton: 'Активировать демо-лицензию',
  activatePlatformButton: 'Активировать демо-лицензию для платформы',
  activateInProgress: 'Активация в процессе...',
  noValidLicenseFound: 'Лицензия не найдена',
  contactYourAdmin:
    'Пожалуйста, свяжитесь с администратором, чтобы обновить лицензию',
  limitIsExceeded:
    'В компании превышен лимит на сотрудников, обратитесь к администратору',
  tariffBox: 'Демо коробочной версии',
  tariffBox1p1: 'полный функционал YouGile Платформы',
  tariffBox1p2: 'на ваших серверах',
  tariffBox2: '100 пользователей',
  tariffBox3: 'Бесплатный доступ на 7 дней',
  tariffBox4: 'Активировать',
  tariffBox5:
    'или воспользуйтесь лицензией для разработчиков и возможностью дополнения системы',
  tariffBox6: 'Лицензия для разработчиков',
  tariffBox7: 'максимум 2 пользователя',

  licenseNotActivated: 'Ваша лицензия не активирована',
  licenseExpired: 'Лицензия истекла',
  contactAdministrator:
    'Свяжитесь с вашим администратором, чтобы продлить лицензию'
}
